import { useEffect, useRef, useState } from "react";
import {GetASD,GroupByForeignKey,GroupByPropCheck,GroupByProps,} from "../Actions/GetContainer";
import { EjercicioByRange } from "./EjercicioByRange";
import { Mes } from "./Mes";
import FilterListIcon from "@mui/icons-material/FilterList";
import TuneIcon from "@mui/icons-material/Tune";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import { FormControl, RadioGroup, FormControlLabel, Radio } from "@mui/material";

export const BoxFiltros = ({
  children,
  onBoxChange,
  boxstate,
  BoxClick,
  titulo_filtro,
  titulo = "",
  subtitulo = "",
}) => {
  const [stateError, setError] = useState("");
  const [value, setValue] = useState();
  const [state, setState] = useState({
    data: [],
    ejercicioinicio: 0,
    periodoinicio: 0,
    ejerciciofin: 0,
    periodofin: 0,
    ejercicio: 0,
    periodo: 0,
    filtrado: "", // Agrega filtrado al estado
  });

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    setState({
      ...state,
      filtrado: newValue, // Actualiza filtrado en el estado
    });
    onBoxChange("filtrado", newValue); // Actualiza el estado del componente padre
  };

  const {
    ejercicioinicio,
    periodoinicio,
    ejerciciofin,
    periodofin,
    ejercicio,
    periodo,
    filtrado,
  } = state;

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const onChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
    onBoxChange(target.name, target.value);
  };

  const onClick = () => {
    const element = document.getElementById("box-structure-bussiness-filtros");
    if (element != undefined && element != null) {
      element.style.display = "flex";
    }
  };

  const onClose = () => {
    const element = document.getElementById("box-structure-bussiness-filtros");
    if (element != undefined && element != null) {
      element.style.display = "none";
    }
    closeConsulta();
  };

  const closeConsulta = () => {};

  const consultar = () => {
    setLoader({ ...loader, mostrar: true });
    BoxClick()
      .then(() => {
        // Eliminar la lógica relacionada con sucursal y departamento
        setLoader({ ...loader, mostrar: false });
        onClose();
      })
      .catch((err) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS FINANCIERO", JSON.stringify(err), "error");
      });
  };

  const GetChildren = (key) => {
    if (children === undefined || children === null) return <></>;
    if (Array.isArray(children)) {
      var result = children.filter((x) => x.key === key);
      if (result !== undefined && result !== null && result.length > 0) {
        return result[0];
      }
    }
    if (children.key === key) return children;

    return <></>;
  };

  return (
    <>
      <LoaderScreen loader={loader} />
      <div className="encabezado-reports-filtros">
        <div>
          <div className="filtro-titulo">
            <button className="boton-box-structure" onClick={onClick}>
              <TuneIcon />
              Filtro
            </button>
            <header>
              <div className="titulo">{titulo}</div>
              <div className="sub-titulo">{subtitulo}</div>
            </header>
          </div>
        </div>
        {GetChildren("box-actions")}
      </div>
      <div
        id="box-structure-bussiness-filtros"
        key="box-structure-bussiness-filtros"
      >
        <div className="filtro-soy-el-titulo">
          <div className="filtro-soy-el-titulo-header">
            {titulo_filtro}
            <span className="filtro-soy-span-close" onClick={onClose}>
              X
            </span>
          </div>
          <div className="filtro-soy-el-titulo-line">
            <div className="filtro-soy-el-titulo-line-bl"></div>
            <div className="filtro-soy-el-titulo-line-circle"></div>
            <div className="filtro-soy-el-titulo-line-br"></div>
          </div>
        </div>

        <div className="box-action-container-filtros">
          <div className="filtro-tiempo-tipo">
            <div className="filtro-group">
              <label>TIPO DE FILTRADO</label>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={value}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="mensual"
                    control={<Radio />}
                    label="MENSUAL"
                    name="radio-mensual"
                  />
                  <FormControlLabel
                    value="semanal"
                    control={<Radio />}
                    label="SEMANAL"
                    name="radio-semanal"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
        </div>
        {value === "mensual" && (
        <div className="filtro-mensual">
        <div className="box-action-container-filtros">
          <div className="filtro-tiempo-tipo">
            <div className="filtro-group">
              <label>EJERCICIO INICIO</label>
              <EjercicioByRange
                name="ejercicioinicio"
                value={ejercicioinicio}
                onChange={onChange}
              />
            </div>
            <div className="filtro-group">
              <label>PERIODO INICIO</label>
              <Mes
                name="periodoinicio"
                value={periodoinicio}
                onChange={onChange}
              />
            </div>
            <div className="filtro-group">
              <label>EJERCICIO FIN</label>
              <EjercicioByRange
                name="ejerciciofin"
                value={ejerciciofin}
                onChange={onChange}
              />
            </div>
            <div className="filtro-group">
              <label>PERIODO FIN</label>
              <Mes name="periodofin" value={periodofin} onChange={onChange} />
            </div>
            {GetChildren("box-filtro")}

            <div className="box-filtros-container-buttons">
              {/* <button className="button-cancel" onClick={onClose}>
                Cancelar
              </button> */}
              <button className="button-accept" onClick={consultar}>
                <FilterListIcon /> CARGAR
              </button>
            </div>
          </div>
        </div>
        </div>
        )}

        {value === "semanal" && (
        <div className="filtro-semanal">
        <div className="box-action-container-filtros">
          <div className="filtro-tiempo-tipo">
            <div className="filtro-group">
              <label>EJERCICIO</label>
              <EjercicioByRange
                name="ejercicio"
                value={ejercicio}
                onChange={onChange}
              />
            </div>
            <div className="filtro-group">
              <label>PERIODO</label>
              <Mes
                name="periodo"
                value={periodo}
                onChange={onChange}
              />
            </div>

            <div className="box-filtros-container-buttons">
              {/* <button className="button-cancel" onClick={onClose}>
                Cancelar
              </button> */}
              <button className="button-accept" onClick={consultar}>
                <FilterListIcon /> CARGAR
              </button>
            </div>
          </div>
        </div>
        </div>
        )}
      </div>
    </>
  );
};

